import { createAction, props } from '@ngrx/store';
import {
  ICountryHelpDocument,
  ICountryHelpDocumentOverview,
  ICountryHelpDocumentRequest,
  ICountryMessage,
  ICountryRequest,
  IPaymentDetails,
  IPaymentDetailsRequest,
} from '../countries.models';
import { IFileUpload } from '../../../damages/damages.models';
import { ICountry } from '../../../shared/services/country.models';

export const loadCountryMessages = createAction(
  '[Countries Manager] Load country messages.'
);
export const loadCountryMessagesSuccess = createAction(
  '[Countries Manager] Load country messages success.',
  props<{ messages: ICountryMessage[] }>()
);
export const loadCountryMessagesFailure = createAction(
  '[Countries Manager] Load country messages failure.',
  props<{ error: unknown }>()
);

export const loadCountryMessage = createAction(
  '[Countries Manager] Load country message.',
  props<{ id: number; loading: boolean }>()
);
export const loadCountryMessageSuccess = createAction(
  '[Countries Manager] Load country message success.',
  props<{ countryMessage: ICountryMessage }>()
);
export const loadCountryMessageFailure = createAction(
  '[Countries Manager] Load country message failure.',
  props<{ error: unknown }>()
);

export const deleteCountryMessage = createAction(
  '[Countries Manager] Delete country message.',
  props<{ id: number }>()
);
export const deleteCountryMessageSuccess = createAction(
  '[Countries Manager] Delete country message success.'
);
export const deleteCountryMessageFailure = createAction(
  '[Countries Manager] Delete country message failure.',
  props<{ error: unknown }>()
);

export const deleteCountryMessagesBulk = createAction(
  '[Countries Manager] Delete country messages in Bulk.',
  props<{ messageIds: number[] }>()
);
export const deleteCountryMessagesBulkSuccess = createAction(
  '[Countries Manager] Delete country messages in Bulk success.',
  props<{ messageIds: number[] }>()
);
export const deleteCountryMessagesBulkFailure = createAction(
  '[Countries Manager] Delete country messages in Bulk failure.',
  props<{ error: unknown }>()
);

export const loadCountries = createAction(
  '[Countries Manager] Load countries.'
);
export const loadCountriesSuccess = createAction(
  '[Countries Manager] Load countries success.',
  props<{ countries: ICountry[] }>()
);
export const loadCountriesFailure = createAction(
  '[Countries Manager] Load countries failure.',
  props<{ error: unknown }>()
);

export const loadCountry = createAction(
  '[Countries Manager] Load country.',
  props<{ id: number; loading: boolean }>()
);
export const loadCountrySuccess = createAction(
  '[Countries Manager] Load country success.',
  props<{ country: ICountry }>()
);
export const loadCountryFailure = createAction(
  '[Countries Manager] Load country failure.',
  props<{ error: unknown }>()
);

export const updateCountry = createAction(
  '[Countries Manager] Update country.',
  props<{ id: number; changes: ICountryRequest }>()
);
export const updateCountrySuccess = createAction(
  '[Countries Manager] Update country success.',
  props<{ country: ICountryRequest }>()
);
export const updateCountryFailure = createAction(
  '[Countries Manager] Update country failure.',
  props<{ error: unknown }>()
);

export const loadCountryDocuments = createAction(
  '[Countries Manager] Load country documents.'
);
export const loadCountryDocumentsSuccess = createAction(
  '[Countries Manager] Load country documents success.',
  props<{ documents: ICountryHelpDocumentOverview[] }>()
);
export const loadCountryDocumentsFailure = createAction(
  '[Countries Manager] Load country documents failure.',
  props<{ error: unknown }>()
);

export const loadCountryDocumentById = createAction(
  '[Countries Manager] Load country document.',
  props<{ id: number; loading: boolean }>()
);
export const loadCountryDocumentByIdSuccess = createAction(
  '[Countries Manager] Load country document success.',
  props<{ document: ICountryHelpDocument }>()
);
export const loadCountryDocumentByIdFailure = createAction(
  '[Countries Manager] Load country document failure.',
  props<{ error: unknown }>()
);

export const updateCountryDocument = createAction(
  '[Countries Manager] Update country document.',
  props<{ id: number; changes: ICountryHelpDocumentRequest }>()
);
export const updateCountryDocumentSuccess = createAction(
  '[Countries Manager] Update country document success.',
  props<{ countryHelpDocument: ICountryHelpDocumentRequest }>()
);
export const updateCountryDocumentFailure = createAction(
  '[Countries Manager] Update country document failure.',
  props<{ error: unknown }>()
);

export const deleteCountryDocument = createAction(
  '[Countries Manager] Delete country document.',
  props<{ id: number }>()
);
export const deleteCountryDocumentSuccess = createAction(
  '[Countries Manager] Delete country document success.'
);
export const deleteCountryDocumentFailure = createAction(
  '[Countries Manager] Delete country document failure.',
  props<{ error: unknown }>()
);

export const deleteCountryDocumentsBulk = createAction(
  '[Countries Manager] Delete country documents in Bulk.',
  props<{ documentIds: number[] }>()
);
export const deleteCountryDocumentsBulkSuccess = createAction(
  '[Countries Manager] Delete country documents in Bulk success.',
  props<{ documentIds: number[] }>()
);
export const deleteCountryDocumentsBulkFailure = createAction(
  '[Countries Manager] Delete country documents in Bulk failure.',
  props<{ error: unknown }>()
);

export const uploadFile = createAction(
  '[Countries Manager] Upload file.',
  props<{ file: IFileUpload }>()
);
export const uploadFileSuccess = createAction(
  '[Countries Manager] Upload file success.'
);
export const uploadFileFailure = createAction(
  '[Countries Manager] Upload file failure.',
  props<{ error: unknown }>()
);

export const createCountryDocument = createAction(
  '[Countries Manager] Create Country Help Document',
  props<{ countryDocument: ICountryHelpDocumentRequest }>()
);
export const createCountryDocumentSuccess = createAction(
  '[Countries Manager] Create ICountry Help Document action completed successfully'
);
export const createCountryDocumentFailure = createAction(
  '[Countries Manager] Create Country Help Document action failure',
  props<{ error: unknown }>()
);

export const loadPaymentDetails = createAction(
  '[Countries Manager] Load payment details.'
);
export const loadPaymentDetailsSuccess = createAction(
  '[Countries Manager] Load payment details success.',
  props<{ paymentDetails: IPaymentDetails[] }>()
);
export const loadPaymentDetailsFailure = createAction(
  '[Countries Manager] Load payment details failure.',
  props<{ error: unknown }>()
);

export const updatePaymentDetails = createAction(
  '[Countries Manager] Update payment details.',
  props<{ id: number; changes: IPaymentDetailsRequest }>()
);
export const updatePaymentDetailsSuccess = createAction(
  '[Countries Manager] Update payment details success.',
  props<{ paymentDetails: IPaymentDetailsRequest }>()
);
export const updatePaymentDetailsFailure = createAction(
  '[Countries Manager] Update payment details failure.',
  props<{ error: unknown }>()
);

export const resetCountryMessage = createAction(
  '[Countries Manager] Reset country message state'
);
export const resetCountryHelpDocumentFile = createAction(
  '[Countries Manager] Reset country help document file state'
);
export const updateCountryHelpDocumentWithNewFile = createAction(
  '[Countries Manager] Update country help document width new file.',
  props<{
    countryDocument: ICountryHelpDocumentRequest & { id: number };
  }>()
);
export const downloadCountryHelpDocument = createAction(
  '[Countries Manager] Download country help document.',
  props<{ id: number }>()
);
export const downloadCountryHelpDocumentSuccess = createAction(
  '[Countries Manager] Download country help document success.',
  props<{ countryHelpDocument: ICountryHelpDocument }>()
);
